import gql from 'graphql-tag'

export const LIST_POLLING_EVENTS = gql`
query ListPollingEventsQuery($userId: ID!, $limit: Int!, $offset: Int!, $isActive: Boolean!, $orderBy: String!, $choiceType: String!) {
  listPollingEvents(userId: $userId, isActive: $isActive, orderBy: $orderBy) {
    results(limit: $limit, offset: $offset) {
      id
      name
      eventDate
      isActive
      pollingEventChoice(choiceType: $choiceType) {
        id       
      }
    }
    totalCount
  }
}
`

export const LIST_POLLING_EVENT_DETAIL = gql`
query ListPollingEventDetailQuery($limit: Int!, $offset: Int!, $eventId: Float!, $choiceType: String!) {
  listPollingEvents(id: $eventId) {
    results(limit: $limit, offset: $offset) {
      id
      name
      eventDate
      isActive
      pollingEventChoice(choiceType: $choiceType) {
        id
        name
        code
        profilechoicetable{
          profile{
            id
          }         
        }
      }
    }
    totalCount
  }
}
`

export const LIST_POLLING_CHOICE_CONTACTS = gql`
query ListChoiceProfile($pollingEventChoiceId:Float!, $offset: Int!, $limit: Int!, $orderBy: String!) {
  listChoiceProfile(pollingChoiceId: $pollingEventChoiceId, profileIsDelete: 0, orderBy: $orderBy) {
    results(limit: $limit, offset: $offset) {
      profile{
        id
        number
        name
        lastName
        avatarImg
        gender
        facebookUrl
        instagramUrl
        lastSmsBody
        hasUnread
        pendingStatus
        profileWorkHistory {
          id
          organization {
            id
            name
          }
          title {
            id
            name
          }
        }
      }          
    }
    totalCount
  }
}
`

export const LIST_EDIT_POLLING_CHOIECE_CONTACTS = gql`
  query ListChoiceProfile($pollingEventChoiceId:Float!, $offset: Int!, $limit: Int!, $orderBy: String!){ 
    listChoiceProfile(pollingChoiceId: $pollingEventChoiceId, profileIsDelete: 0, orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          birthyear
          bdayTags (name: "birthday"){
            id
            intValue
            strValue
            name
          }
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }                     
          }
        }
      }
      totalCount
    }
  }
`
